import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { SupportComponent } from '../../shared/components/support/support.component';

@Component({
  selector: 'app-provider-support',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    SupportComponent
  ],
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
})
export class ProviderSupportComponent {}



